import {
    AmountSeries,
    SuppliersSpendVolumeResponse
} from '@lsq-frontend/remote-services/analytics-graphql/src/lib/utils/types';
import { ChartFilters, SpendVolumeOverview } from './chart-types';
import chartUtils, { dateSort, mapCentsToDollars } from './chart-utils';
import { DateFormat } from '@lsq-frontend/common-ui';
import { format } from 'date-fns';

const getSpendVolumeOverviewConfig = (data: SpendVolumeOverview) => {
    const abbrevi = chartUtils.getDataLabelAbbreviator();
    const chartConfig = {
        chart: {
            type: 'column',
            height: '260px'
        },
        title: {
            text: null,
            align: 'left'
        },
        xAxis: {
            categories: data.categories,
            title: {
                text: 'Invoice Date',
                style: chartUtils.getTextStyle()
            },
            labels: {
                style: chartUtils.getTextStyle()
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'AP Spend ($)',
                style: chartUtils.getTextStyle()
            },
            stackLabels: {
                enabled: false
            },
            labels: {
                style: chartUtils.getTextStyle()
            }
        },
        tooltip: {
            style: chartUtils.getTextStyle(),
            formatter: function (this: any) {
                const header = `Month of Payment Created Date: <b>${this.x}</b><br/>`;
                const body =
                    this.series.name + ' : <b>' + chartUtils.abbreviatorFormatter(this.y) + '</b>';
                return '<div>' + header + body + '</div>';
            }
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true
                }
            },
            series: {
                groupPadding: 0.1,
                pointPadding: 0.001
            }
        },
        exporting: {
            enabled: false
        },
        colors: ['#406d9a', '#44974b'],
        series: [
            {
                name: 'Invoice Amount',
                showInLegend: false,
                data: data.invoiceAmount.map(mapCentsToDollars),
                ...abbrevi
            },
            {
                name: 'Early Paid Amount',
                showInLegend: false,
                data: data.earlyPaidAmount.map(mapCentsToDollars),
                ...abbrevi
            }
        ]
    };
    return chartConfig;
};

export default getSpendVolumeOverviewConfig;

export const GetSpendVolumeOverviewSchema = (
    data: SuppliersSpendVolumeResponse,
    filters: ChartFilters
) => {
    if (data.suppliers.length === 0) {
        throw new Error('Empty data');
    }
    const filterNMonths = 9;
    let invoiceAmount: number[] = [];
    let earlyPaidAmount: number[] = [];
    for (const supp of data.suppliers) {
        for (let [indx, slot] of supp.amountSeries.sort(dateSort).entries()) {
            invoiceAmount[indx] = (invoiceAmount[indx] ?? 0) + slot.invoiceAmount.cents;
            earlyPaidAmount[indx] = (earlyPaidAmount[indx] ?? 0) + slot.fundedAmount.cents;
        }
    }

    const categories = data.suppliers[0].amountSeries
        .sort(dateSort)
        .map((serie: AmountSeries) => format(serie.date, DateFormat.MonthNumberDashYear));

    const schema = getSpendVolumeOverviewConfig({
        invoiceAmount: invoiceAmount.slice(-filterNMonths),
        earlyPaidAmount: earlyPaidAmount.slice(-filterNMonths),
        categories: categories.slice(-filterNMonths)
    });
    return schema;
};
